import api from '../../../../util/api'

const endpoint = "/interface/v1/product-video/"

export default {
  list({ commit }) {
    return new Promise((resolve, reject) => {
      api.get(endpoint)
        .then(res => res.json())
        .then(data => {
          commit("set", { data });
          resolve(data);
          console.log("aqui", data);
        }).catch(e => reject(e));
    });
  },
  get({ commit }, { id }) {
    api.get(endpoint + id)
      .then(res => res.json())
      .then(data => {
        commit("show", { data });
        console.log("aqui", data);
      });
  },
  async listSort({ commit }, { sort }) {
    try {
      const res = await api.get(endpoint + sort);
      const data = await res.json();
      commit("set", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  create({ commit }, { item }) {
    return new Promise((resolve, reject) => {
      api.post(endpoint, item)
        .then(res => res.json())
        .then(data => {
          resolve(data);
          console.log("aqui", data);
        }).catch(e => reject(e));
    });
  },
  createForm({ commit }, { item }) {
    return new Promise((resolve, reject) => {
      api.postForm(endpoint, item)
        .then(res => res.json())
        .then(data => {
          resolve(data);
          console.log("aqui", data);
        }).catch(e => reject(e));
    });
  },
  update({ commit }, { item }) {
    return new Promise((resolve, reject) => {
      api.put(endpoint + item.id, item)
        .then(res => res.json())
        .then(data => {
          resolve(data);
          console.log("aqui", data);
        }).catch(e => reject(e));
    });
  },
  updateForm({ commit }, { item }) {
    return new Promise((resolve, reject) => {
      api.putForm(endpoint + item.id, item)
        .then(res => res.json())
        .then(data => {
          resolve(data);
          console.log("aqui", data);
        }).catch(e => reject(e));
    });
  },
  delete({ dispatch }, { id }) {
    api.delete(endpoint + id)
      .then(() => {
        dispatch("list");
      });
    console.log("deleted")
  },
}